// Bespoke Construction Services - REAL DATA from bespokeconstruction.co.uk

export const COMPANY = {
  name: "Bespoke",
  legal: "Bespoke Construction Services",
  short: "Bespoke",
  tagline: "Built from a different perspective",
  philosophy: "A business built on people.",
  description:
    "Bespoke Construction Services is an award-winning UK construction company specialising in interior fit-out and residential construction services nationwide.",
  established: 1999,
  founder: "Marvin Bennett",
  address: "Merlin House, Halesfield 19, Telford, Shropshire TF7 4QT",
  region: "Shropshire · Nationwide UK",
  phone: "01952 588816",
  phoneTel: "+441952588816",
  email: "info@bespokeconstruction.co.uk",
  ig: "https://www.instagram.com/",
  li: "https://www.linkedin.com/company/bespoke-construction-services-ltd/",
};

export const NAV = [
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Projects", path: "/projects" },
  { label: "News", path: "/news" },
  { label: "Careers", path: "/careers" },
  { label: "Contact", path: "/contact" },
];

export const HERO = {
  title: "Built from a different perspective.",
  sub: "An award-winning UK construction studio operating since 1999. Interior fit-out, residential new build, and conversion — delivered nationwide with precision, integrity and a relentless attention to detail.",
  awards: ["FIS Certificate of Excellence", "ICW Awards", "NHBC Approved", "CHAS Premium", "FDIS Certificated"],
};

export const SERVICES = [
  {
    id: "interiors",
    code: "01",
    title: "Interiors",
    tag: "Fit-out & Finishing",
    short:
      "We excel in delivering the highest quality interior fit-out projects in office and distribution sectors. Acting as both Principal and Sub-Contractor.",
    long:
      "We excel in delivering the highest quality interior fit-out projects in office and distribution sectors. Our expertise has gained us a reputation of service excellence with end-users including Amazon, Marks & Spencer, Lidl, Ocado, DPD, Jaguar Land Rover, Shropshire NHS Trust, First Industrial and Donnington Race Track.",
    image:
      "https://images.unsplash.com/photo-1581784878214-8d5596b98a01?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    bullets: [
      "Cat A & Cat B fit-out",
      "Drylining & joinery",
      "Mezzanine floors",
      "Office & distribution",
      "M&E coordination",
      "Snagging & aftercare",
    ],
  },
  {
    id: "construction",
    code: "02",
    title: "Construction",
    tag: "Principal Contractor",
    short:
      "Our expertise in the residential sector enables us to deliver new build homes, permitted development conversions and contemporary apartments without compromising on value or quality.",
    long:
      "From a single new build property to a small development to contemporary apartments — we are committed to delivering maximum value. We operate in Principal Contractor capacity for our clients and can deliver both traditional and design and build schemes.",
    image:
      "https://images.unsplash.com/photo-1601074231509-dce351c05199?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    bullets: [
      "Residential new build",
      "Permitted development conversion",
      "Contemporary apartments",
      "Design & build schemes",
      "Traditional schemes",
      "Site management",
    ],
  },
];

export const SECTORS = [
  "Office Fit-Out",
  "Distribution",
  "Industrial",
  "Residential",
  "Build-to-Rent",
  "Student Living",
  "Conversion",
  "New Build",
  "Healthcare",
];

export const STATS = [
  { value: 26, suffix: "+", label: "Years Established" },
  { value: 380, suffix: "+", label: "Projects Delivered" },
  { value: 12, suffix: "", label: "Industry Awards" },
  { value: 100, suffix: "%", label: "Repeat Client Rate" },
];

export const PROJECTS = [
  {
    id: "project-completion-greater-manchester",
    code: "01",
    title: "Astley Park, Greater Manchester",
    location: "Greater Manchester",
    sector: "Office Fit-Out",
    role: "Principal Contractor",
    year: 2026,
    summary: "Project Completion at Astley Park — high-quality interior fit-out delivered on time and to specification.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2026/02/Astley-Park-2-840x600.jpg",
  },
  {
    id: "randlay-avenue-telford",
    code: "02",
    title: "Randlay Avenue",
    location: "Telford",
    sector: "Residential",
    role: "Principal Contractor",
    year: 2025,
    summary: "Residential development at Randlay Avenue — contemporary new build apartments and homes.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/12/Randlay-CGI-840x501.png",
  },
  {
    id: "ca1m-doncaster",
    code: "03",
    title: "CA1M Doncaster",
    location: "Doncaster",
    sector: "Distribution",
    role: "Principal Contractor",
    year: 2025,
    summary: "Major distribution facility fit-out delivered for first industrial occupier in Doncaster.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/11/IMG_4102-840x600.jpg",
  },
  {
    id: "dc2-marston-gate",
    code: "04",
    title: "DC2 Marston Gate",
    location: "Marston Gate",
    sector: "Distribution",
    role: "Sub-Contractor",
    year: 2025,
    summary: "DC2 distribution centre fit-out at Marston Gate.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/09/MG4-840x600.jpeg",
  },
  {
    id: "plot-9-derby",
    code: "05",
    title: "Plot 9 Derby",
    location: "Derby",
    sector: "Industrial",
    role: "Principal Contractor",
    year: 2025,
    summary: "Plot 9 Derby industrial fit-out delivered to a national distribution end-user.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/07/IMG_3330-840x600.jpeg",
  },
  {
    id: "fairham-nottingham",
    code: "06",
    title: "Fairham, Nottingham",
    location: "Nottingham",
    sector: "Residential",
    role: "Principal Contractor",
    year: 2025,
    summary: "Residential new-build scheme at Fairham, Nottingham — traditional and design-and-build delivery.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/06/IMG_8713-840x600.jpg",
  },
  {
    id: "newport-pagnell",
    code: "07",
    title: "Newport Pagnell",
    location: "Newport Pagnell",
    sector: "Residential",
    role: "Principal Contractor",
    year: 2025,
    summary: "Residential development at Newport Pagnell — contemporary new-build homes.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/06/20-1-840x600.jpg",
  },
  {
    id: "project-queen",
    code: "08",
    title: "Project Queen",
    location: "Confidential",
    sector: "Office Fit-Out",
    role: "Principal Contractor",
    year: 2025,
    summary: "Confidential prestige interior fit-out delivered for a private corporate client.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/07/IMG_3141-840x600.jpeg",
  },
  {
    id: "st-modwen-burton",
    code: "09",
    title: "St Modwen, Burton",
    location: "Burton",
    sector: "Office Fit-Out",
    role: "Principal Contractor",
    year: 2025,
    summary: "Completion of St Modwen Burton — reception feature wall and full ground-floor fit-out.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/06/GF-Reception-Feature-Wall-840x600.jpeg",
  },
  {
    id: "sloane-street-jewellery-quarter",
    code: "10",
    title: "Sloane Street, Jewellery Quarter",
    location: "Birmingham",
    sector: "Residential",
    role: "Principal Contractor",
    year: 2025,
    summary: "Latest residential development in Birmingham’s historic Jewellery Quarter — contemporary apartments.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/03/Slone-Street.jpg",
  },
  {
    id: "boulevard-bristol-street",
    code: "11",
    title: "Boulevard, Bristol Street",
    location: "Birmingham",
    sector: "Build-to-Rent",
    role: "Principal Contractor",
    year: 2024,
    summary: "Major BtR scheme on Bristol Street, Birmingham. Topping-out reached and Cat A fit-out under way.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2024/10/BS-July-840x600.jpg",
  },
  {
    id: "wolo-house-birmingham",
    code: "12",
    title: "Wolo House",
    location: "Birmingham",
    sector: "Residential",
    role: "Principal Contractor",
    year: 2023,
    summary: "Wolo House Birmingham — residential conversion delivering contemporary apartment living.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2024/10/wolo-3-840x600.jpg",
  },
  {
    id: "gunsmith-house-birmingham",
    code: "13",
    title: "Gunsmith House",
    location: "Birmingham",
    sector: "Residential",
    role: "Principal Contractor",
    year: 2023,
    summary: "Gunsmith House Birmingham — sensitive restoration and conversion to residential apartments.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2023/03/IMG_5178-840x600.jpg",
  },
  {
    id: "greyfriars-coventry",
    code: "14",
    title: "Greyfriars",
    location: "Coventry",
    sector: "Student Living",
    role: "Principal Contractor",
    year: 2022,
    summary: "Conversion and extension of an existing commercial office block into 80 student apartments under a Design & Build Contract.",
    image: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "the-acorns-admaston",
    code: "15",
    title: "The Acorns, Admaston",
    location: "Telford",
    sector: "Residential",
    role: "Principal Contractor",
    year: 2022,
    summary: "Prestige homes development at Admaston, Telford — luxury new-build family residences.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2022/06/Finalss_9-Photo-560x800.jpg",
  },
  {
    id: "sapphire-court-london",
    code: "16",
    title: "Sapphire Court",
    location: "London",
    sector: "Conversion",
    role: "Principal Contractor",
    year: 2021,
    summary: "Office-to-residential conversion delivering luxury apartments — “the best conversion project we have, to date, been involved in.” — Investin PLC.",
    image: "https://images.unsplash.com/photo-1594484208280-efa00f96fc21?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    quote: "Wake Morley Architects have an excellent working relationship with Bespoke Construction and have always found them to be focussed, organised and cooperative in their approach to the delivery of construction projects. Wake Morley Architects have no hesitation in recommending Bespoke Construction for both commercial & residential projects.",
    author: "Adam Morley",
    role: "Director, Wake Morley Architects",
  },
  {
    id: 2,
    quote: "Having worked alongside Bespoke Construction for over 20 years, I could not speak more highly of the level of service they provide. Not once have I experienced a dispute or delay in a contract. Their consistency in both quality and punctuality is why we at Winvic Construction share such a longstanding and successful relationship with Bespoke.",
    author: "Richard Butler",
    role: "Operations Director, Winvic Construction",
  },
  {
    id: 3,
    quote: "The Sapphire Court conversion is the best conversion project we have, to date, been involved in. The delivery and product provided by Bespoke Construction is exceptional. We hope to do many more projects together.",
    author: "Jon Burgwin",
    role: "Director, Investin PLC",
  },
  {
    id: 4,
    quote: "BCS were instrumental in turning a very ambitious concept into a viable project, working very closely with the Client and Design team during the pre-contract and delivery phases. The Client’s team were delighted with the service from Bespoke Construction Services and would not hesitate to include them on future Tendering opportunities.",
    author: "Gareth Powell BSc (Hons) ICIOB MAPM",
    role: "Employer’s Agent · Greyfriars Coventry",
  },
  {
    id: 5,
    quote: "I found the work undertaken by Bespoke Construction of first-class nature.",
    author: "Gary Danks",
    role: "Lafarge",
  },
  {
    id: 6,
    quote: "This is the third scheme that Bespoke have worked on for us now, and in everyone the professional and commercial approach of the company has been impressive.",
    author: "Dominic Goold",
    role: "Goold Estates",
  },
  {
    id: 7,
    quote: "We thoroughly appreciate all your help in the refurbishment of our offices and thank you for the high standards achieved.",
    author: "Sarah Tyrer",
    role: "Savills",
  },
  {
    id: 8,
    quote: "The client is extremely pleased with the quality of the building and in his words stated “the best job he has seen at Prologis by a country mile.”",
    author: "Danny Cross",
    role: "Winvic Construction",
  },
  {
    id: 9,
    quote: "The team, both on site and office based, have been superb in their manner, attitude and knowledge. This has resulted in a successfully delivered building, both on time and budget.",
    author: "Mark Kennedy",
    role: "Managing Director, loc8 Developments Ltd",
  },
  {
    id: 10,
    quote: "The superb new building we now occupy is a testimony to the high standards achieved by the business in helping us fulfil our expectations.",
    author: "David Webster",
    role: "Hanley Economic Building Society",
  },
  {
    id: 11,
    quote: "I would like to convey my thanks for a project that was completed to a very high standard, of which we’re extremely pleased to hand over to our mutual client with a great deal of satisfaction.",
    author: "Richard Powell",
    role: "St Modwen",
  },
  {
    id: 12,
    quote: "The judges were so impressed by the high standards of workmanship and technical expertise demonstrated on your project it has been awarded a certificate of excellence.",
    author: "Jane Cook",
    role: "FIS",
  },
  {
    id: 13,
    quote: "Bespoke delivered an exceptional product for a difficult project.",
    author: "Neil Strelitz",
    role: "Orwell / Pears Property",
  },
  {
    id: 14,
    quote: "I have had a working relationship with Bespoke and Marvin for over ten years now. I’ve always found them a pleasure to deal with. Committed to delivering a quality product every time.",
    author: "Seb Horst",
    role: "Development Manager, Tiger Developments",
  },
  {
    id: 15,
    quote: "Bespoke’s commitment to Innovation, Productivity, Health, Safety & the Environment are strongly aligned with Hilti’s own values and this makes them a pleasure to work with from office to site.",
    author: "Chris Murphy",
    role: "Regional Account Manager, Hilti",
  },
];

export const NEWS = [
  {
    id: "bristol-street-birmingham",
    title: "Bristol Street, Birmingham",
    date: "2025-07-25",
    category: "Project Update",
    excerpt: "Topping-out reached on the Boulevard scheme on Bristol Street, with envelope and Cat A fit-out now under way across the lower floors.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2024/10/BS-25.07.2025-first-840x600.jpg",
  },
  {
    id: "progress-update-st-chads",
    title: "Progress Update At St Chads, Birmingham",
    date: "2025-06-18",
    category: "Project Update",
    excerpt: "St Chads continues at pace with 1st-fix drylining now across various floors of the former St Chads Hospital, carried out by our in-house fit-out team.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/06/IMG_8514-840x600.jpg",
  },
  {
    id: "copper-quarter-birmingham",
    title: "Copper Quarter, Birmingham",
    date: "2025-06-02",
    category: "Project Update",
    excerpt: "Bespoke is pleased to announce the start of works at Copper Quarter, Birmingham — a contemporary residential scheme.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/06/Copper-Quarter.png",
  },
  {
    id: "st-chads-court-birmingham",
    title: "Contract Awarded — St Chads Court, Birmingham",
    date: "2025-02-20",
    category: "Award",
    excerpt: "We are delighted to announce the award of the St Chads Court contract — a major Birmingham conversion programme.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/02/1736972034131-840x600.jpg",
  },
  {
    id: "bristol-street-topping-out",
    title: "Bristol Street Topping Out Ceremony",
    date: "2025-02-10",
    category: "Project Update",
    excerpt: "Bristol Street, Birmingham reached topping-out, marked by a ceremony with the client team and supply chain.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2025/02/Bristol-Street-Topping-Out-1-800x600.jpg",
  },
  {
    id: "wolo-house",
    title: "Wolo House, Birmingham",
    date: "2023-03-15",
    category: "Project Update",
    excerpt: "Wolo House conversion is progressing well, delivering contemporary apartments in central Birmingham.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2023/03/wolo-2-840x600.jpeg",
  },
  {
    id: "gunsmith-house",
    title: "Gunsmith House, Birmingham",
    date: "2023-03-02",
    category: "Project Update",
    excerpt: "Gunsmith House restoration nearing handover — sensitive heritage conversion to residential apartments.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2023/03/IMG_5178-840x600.jpg",
  },
  {
    id: "supported-living",
    title: "Supported Living Development Secured",
    date: "2022-07-20",
    category: "Award",
    excerpt: "We are delighted to have secured a new supported-living development project with a long-standing client.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2022/07/thumbnail-840x600.jpg",
  },
  {
    id: "blue-earth-stoke",
    title: "Interior Fit-out for Blue Earth Construction, IAE Stoke",
    date: "2022-07-12",
    category: "Project Update",
    excerpt: "Interior fit-out completed for Blue Earth Construction at IAE Stoke, on time and on budget.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2022/07/6.jpg",
  },
  {
    id: "the-acorns-admaston",
    title: "The Acorns, Admaston",
    date: "2022-06-20",
    category: "Project Update",
    excerpt: "Prestige homes at Admaston, Telford near completion — family residences finished to the highest standard.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2022/06/Finalss_9-Photo-560x800.jpg",
  },
];

export const TEAM = [
  {
    id: "marvin-bennett",
    name: "Marvin Bennett",
    role: "Founder & Managing Director",
    bio: "Marvin founded Bespoke in 1999 and has personally overseen the delivery of every flagship scheme since. His values — honesty, flexibility and innovation — sit at the heart of the studio.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2022/08/marvin-800x800.jpg",
  },
  {
    id: "mark-evans",
    name: "Mark Evans",
    role: "Construction Director",
    bio: "Mark leads our residential and conversion delivery, bringing two decades of Tier-1 experience to every Bespoke build.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2022/08/mark-800x800.jpg",
  },
  {
    id: "paul-jackson",
    name: "Paul Jackson",
    role: "Interiors Director",
    bio: "Paul oversees our interior fit-out division and our long-standing relationships with national distribution and retail end-users.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2022/08/Paul-J-800x800.jpg",
  },
  {
    id: "natalie-bennett",
    name: "Natalie Bennett",
    role: "Director",
    bio: "Natalie oversees the business operations and the studio’s long-term strategy alongside the founding director.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2020/11/NAt-800x800.jpg",
  },
  {
    id: "gary-kendrick",
    name: "Gary Kendrick",
    role: "Commercial Director",
    bio: "Gary leads commercial strategy, procurement and value engineering across both Interior and Construction divisions.",
    image: "https://bespokeconstruction.co.uk/wp-content/uploads/2022/08/gary-k-800x800.jpg",
  },
];

export const PARTNERS = [
  "Amazon",
  "Marks & Spencer",
  "Lidl",
  "Ocado",
  "DPD",
  "Jaguar Land Rover",
  "Shropshire NHS Trust",
  "First Industrial",
  "Donnington Race Track",
  "Winvic",
  "Investin PLC",
  "St Modwen",
  "Goold Estates",
  "Savills",
  "Lafarge",
  "Hilti",
];

export const ACCREDITATIONS = [
  "NHBC",
  "CHAS",
  "Constructionline",
  "FIS Accredited",
  "FDIS Certificated Inspector",
  "ICW Insured",
  "METSEC Approved",
  "ISO 9001",
];

export const CAREERS = [
  {
    id: "site-manager",
    title: "Site Manager",
    location: "Birmingham / West Midlands",
    type: "Full-time",
    summary: "Lead the day-to-day delivery of a residential conversion programme, reporting to the Construction Director.",
  },
  {
    id: "quantity-surveyor",
    title: "Quantity Surveyor",
    location: "Telford HQ",
    type: "Full-time",
    summary: "Manage cost, value reporting and final accounts across multiple BtR and conversion projects.",
  },
  {
    id: "fit-out-foreman",
    title: "Fit-out Foreman",
    location: "Nationwide",
    type: "Full-time",
    summary: "Run our in-house drylining and fit-out gangs on Cat A and Cat B distribution and office projects.",
  },
  {
    id: "trainee-pm",
    title: "Trainee Project Manager",
    location: "Telford HQ",
    type: "Graduate",
    summary: "Two-year graduate scheme rotating across both divisions, with mentoring from a board director.",
  },
];

export const FAQ = [
  {
    q: "How long has Bespoke been in business?",
    a: "Bespoke was founded in 1999 by Marvin Bennett and has delivered award-winning interior fit-out and construction projects nationwide for over 25 years.",
  },
  {
    q: "Where do you operate?",
    a: "We are headquartered in Telford, Shropshire and deliver nationwide. Active sites currently include Birmingham, Manchester, Doncaster, Derby, Nottingham, Newport Pagnell and London.",
  },
  {
    q: "Do you operate as Principal Contractor and Sub-Contractor?",
    a: "Yes. We deliver schemes in both roles. Our in-house fit-out teams are frequently engaged by Tier-1 main contractors including Winvic.",
  },
  {
    q: "What sectors do you serve?",
    a: "Office fit-out, distribution, industrial, residential new build, conversion, BtR, student living and healthcare. Our end-users include Amazon, Marks & Spencer, Lidl, Ocado, DPD and Jaguar Land Rover.",
  },
  {
    q: "What accreditations do you carry?",
    a: "NHBC, CHAS, Constructionline, FIS Accredited Member, FDIS Certificated Inspector, ICW Insured and METSEC Approved.",
  },
];
